var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      class: [
        {
          transient: _vm.rowdata.processing,
          new: _vm.rowdata.id == "",
          remove: _vm.rowdata.savePending == "delete"
        },
        _vm.customTRClasses
      ]
    },
    [
      _vm._t("select"),
      _vm._v(" "),
      _vm._l(_vm.columns, function(column, columnIdx) {
        return _c(
          "td",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showColumn(column),
                expression: "showColumn( column )"
              }
            ],
            key: "column-" + columnIdx,
            class: column.columnClass,
            attrs: { tabindex: "0" }
          },
          [
            _vm._t(column.customCol, [
              column.type === "index"
                ? _c("span", [
                    _vm._v("\n\t\t\t\t" + _vm._s(_vm.rowIndex + 1) + "\n\t\t\t")
                  ])
                : column.type === "link" && _vm.useAnchor
                ? _c("span", [
                    _c("a", { attrs: { href: _vm.getFullLink(column.link) } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.formatValue(
                              column.type,
                              _vm.getProp(_vm.rowdata, column.key)
                            )
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ])
                : column.type === "link" && !_vm.useAnchor
                ? _c(
                    "span",
                    [
                      _c("router-link", { attrs: { to: _vm.rowdata.LINK } }, [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.formatValue(
                                column.type,
                                _vm.getProp(_vm.rowdata, column.key)
                              )
                            ) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  )
                : column.type === "count"
                ? _c("span", [
                    _c("span", { staticClass: "badge badge-primary" }, [
                      _vm._v(
                        _vm._s(_vm.getProp(_vm.rowdata, column.key).length)
                      )
                    ])
                  ])
                : column.type === "list"
                ? _c("span", [
                    _c(
                      "ul",
                      _vm._l(_vm.getProp(_vm.rowdata, column.key), function(
                        li,
                        index
                      ) {
                        return _c("li", { key: "rowData_" + index }, [
                          _vm._v("\n\t\t\t\t\t\t" + _vm._s(li) + "\n\t\t\t\t\t")
                        ])
                      }),
                      0
                    )
                  ])
                : column.type === "html"
                ? _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        "<div>" +
                          _vm.formatValue(
                            column.type,
                            _vm.getProp(_vm.rowdata, column.key)
                          ) +
                          "</div>"
                      )
                    }
                  })
                : column.type === "bar"
                ? _c("div", [
                    _c("div", { staticClass: "col-xs-10" }, [
                      _c("div", { staticClass: "progress" }, [
                        _c("div", {
                          staticClass: "progress-bar",
                          class: _vm.getProgressClass(_vm.rowdata[column.key]),
                          style: { width: _vm.rowdata[column.key] + "%" },
                          attrs: {
                            role: "progressbar",
                            "aria-valuenow": "60",
                            "aria-valuemin": "0",
                            "aria-valuemax": "100"
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-2" }, [
                      _c("span", { staticClass: "text-lg" }, [
                        _c("strong", [_vm._v(_vm._s(_vm.rowdata[column.key]))])
                      ])
                    ])
                  ])
                : _c("span", { class: column.contentClass }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.formatValue(
                            column.type,
                            _vm.getProp(_vm.rowdata, column.key)
                          )
                        ) +
                        "\n\t\t\t"
                    )
                  ])
            ])
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.showActions
        ? _c(
            "td",
            { staticClass: "action-column", attrs: { tabindex: "0" } },
            [_vm._t("actions")],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }